import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { AppComponent } from './app.component';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { RouterModule }   from '@angular/router';
import { HomeComponent } from './home/home.component';
import { GalleryComponent } from './gallery/gallery.component';
import { ProfileComponent } from './profile/profile.component';
import { HobbiesComponent } from './hobbies/hobbies.component';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    GalleryComponent, 
    ProfileComponent,
    HobbiesComponent
  ],
  imports: [
    BrowserModule,
    HttpModule,
    HttpClientModule,
    RouterModule.forRoot([
      { path: '', redirectTo: '/home', pathMatch: 'full'},   
             
      { path: 'home', component: HomeComponent},
      { path: 'me/home', component: HomeComponent},
      { path: 'gallery', component: GalleryComponent},
      { path: 'me/gallery', component: GalleryComponent},
      { path: 'profile', component: ProfileComponent},
      { path: 'hobbies', component: HobbiesComponent}

    ],{useHash: true})
    
  ],
  providers: [HttpClient],
  bootstrap: [AppComponent]
})
export class AppModule { }




// WEBPACK FOOTER //
// /Users/haydenso/Desktop/Code/Projects/haydensookchand/website_source/src/app/app.module.ts